import * as errorStrings from "../../enums/errorStrings";
import isEqual from "lodash.isequal";
import localforage from "localforage";

const sessionId = Date.now();

/*
 * Accepts a function that goes to the network for cacheable data and returns a function that wraps
 * the network request in a check against the browser cache. Defaults to 10 minute expiration time
 */
export default function cacheEnhancer(
	fetcher,
	storageKey,
	expirySeconds = 600,
	singleSession = false,
) {
	return (...args) => {
		let apiResponse;
		return localforage
			.getItem(storageKey)
			.then(value => {
				if (
					value &&
					Date.now() <= value.expiresAt &&
					isEqual(value.params, args) &&
					value.clientVersion === __VERSION__ &&
					(!singleSession || (singleSession && sessionId === value.sessionId))
				) {
					return value.data;
				}

				return fetcher(...args)
					.then(data => {
						apiResponse = data;
						return localforage.setItem(storageKey, {
							clientVersion: __VERSION__,
							data,
							expiresAt: Date.now() + expirySeconds * 1000,
							params: args,
							sessionId,
						});
					})
					.then(obj => obj.data);
			})
			.catch(err => {
				if (err && err.name === errorStrings.QUOTA_EXCEEDED) {
					if (__DEV__) {
						console.warn(
							"Browser cache limit exceeded-- using, but not caching, original api response.",
						);
					}
				}
				if (apiResponse) {
					return Promise.resolve(apiResponse);
				}

				// Re-try API request if something went wrong with local forage OR the first request rejected
				return fetcher(...args);
			});
	};
}
